import fetch from "@/utils/fetch";
// import {api_url} from "../popular/index"
const api_url = process.env.VUE_APP_API;

export const new_publish = (data) =>
  fetch({
    //手机号密码登录
    url: `${api_url}/appVersion`,
    method: "post",
    data,
  });
export const update_publish = (data) =>
  fetch({
    //三方登录
    url: `${api_url}/appVersion`,
    method: "put",
    data,
  });
export const delete_publish = (data) =>
  fetch({
    //三方登录
    url: `${api_url}/appVersion`,
    method: "delete",
    data,
  });
export const get_publish = (data) =>
  fetch({
    //手机号密码登录
    url: `${api_url}/appVersion`,
  });

export const getUploadSignature = (name) =>
  fetch({
    url: `${api_url}/app/upload/signature?fileName=${name}`,
  });

export const setAuditiong = (data) =>
  fetch({
    url: `${api_url}/appVersion/auditing?auditing=${data.auditing}&client=${data.client}&versionName=${data.versionName}`,
    method: "put",
    data,
  });
